$(document).ready(function(){
  $(".btn-open-search-drawner").click(function(){
    $(this).toggleClass("serchactive");
    $(".shopify-section-header").toggleClass("serchactive-header");  
    $("body").toggleClass("serchactive-body");
    $(".header-main-search").toggle();
  });
});


 $(document).ready(function(){ 
 $(".header-icon.open-cart-tray").click(function(event){    
  event.preventDefault();
    $(".slidecarthq-overlay").addClass("open");     
    $(".slidecarthq").addClass("open");
  }); 
});  



$(".header-main-search").scroll(function() {
    if ($(this).scrollTop() > 100) {
       $('body.serchactive-body').addClass('hideheader');
    } else {
       $('body.serchactive-body').removeClass('hideheader');
    }
});

 (function readMoreOurStory () {
    const btnReadMore = document.getElementById('read-more-our-story');
    const fullOurStory = document.querySelector('.we-are-born-about-us .full-content');

    if (btnReadMore) {
      btnReadMore.onclick = function() {
        if (this.innerText == 'Read more ') {
          this.innerText = 'Read less ';
          fullOurStory.style.maxHeight = '5000px';
          
          window.scroll({
            top: fullOurStory.getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth'
          });
        } else {
          this.innerText = 'Read more ';
          fullOurStory.style.maxHeight = '0px';
        }
      }
    }
  })();

 (function theAncestralTenetsDropDown() {
    const btnDropDowns = document.querySelectorAll('.the-ancestral-tenets-about-us .icon-drop-down');

    const checkOpen = (e) => {
      if (e.classList.contains('open')) {
        return true;
      }
      return false;
    }

    if (btnDropDowns) {
      btnDropDowns.forEach((btnDropDown) => {
      btnDropDown.onclick = function () {
          const content = this.parentNode.children[1];
  
          if (!checkOpen(this)) {
            this.style.transform = 'rotate(180deg)';
            content.style.maxHeight = '999px';
            this.classList.add('open');
          } else {
            this.style.transform = 'rotate(0)';
            content.style.maxHeight = '0';
            this.classList.remove('open');
          }
          
        } 
      });
    }
  })();

(function textTrayProductCOA () {
    const textTray = document.querySelector('.quality-control-product-coa .text-tray');

    if (textTray) {
      window.addEventListener('scroll', () => {
        let screenPartHeight = (window.innerHeight / 100) * 85;
        let positionTextTray = textTray.getBoundingClientRect();
        let rightEle = positionTextTray.bottom - screenPartHeight;
  
        if (rightEle > 10) {
          textTray.style.right = `-${rightEle}px`;
        } else {
          textTray.style.right = `${rightEle * -1}px`;
        }
      }); 
    }
  })();

 (function lightBoxCertificateProductCoa () {
    const openLightBox = document.querySelector('.light-box-open');
    const lightBox = document.querySelectorAll('.certificate-light-box');
    const overlayClose = document.querySelectorAll('.bg-blur');
    const btnClose = document.querySelectorAll('.certificate-close-btn');

    if (openLightBox && overlayClose && lightBox && btnClose) {
      openLightBox.onclick = () => {
        lightBox[0].style.display = 'flex';
      }
      
      overlayClose.forEach(o => {
        o.onclick = () => {
          lightBox.forEach(e => e.style.display = 'none');
        }
      })
      
      btnClose.forEach(b => {
        b.onclick = () => {
          lightBox.forEach(e => e.style.display = 'none');
        }
      })
    }

  })();



$(document).ready(function() {
	$("#modern-world-accessories").insertAfter("#up-upsell-carousel");

document.querySelectorAll('.product--info-form .cs-klaviyo-bis-trigger').forEach(link => {
  link.removeAttribute('target');
});
  
});

$(document).ready(function() {
  const links = document.querySelectorAll("a[target='_blank']"); // Select links with target="_blank"

  links.forEach(link => {
    // Add a title attribute if not already present
    if (!link.hasAttribute("title")) {
      link.setAttribute("title", "Opens in a new tab");
    }

    // Add aria-describedby attribute if not already present
    if (!link.hasAttribute("aria-describedby")) {
      link.setAttribute("aria-describedby", "Opens in a new tab");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const openCartTray = document.querySelector('.open-cart-tray');
  if (openCartTray) {
    openCartTray.addEventListener('click', function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  window.checkedFirstInputValue = '';
  const verticalFilters = document.querySelector('.collection-grid-main facet-filters-form .list-menu__item input:checked');
  const collectionBanner = document.querySelector('.collection-banner-row.filter-query');

  if (verticalFilters && collectionBanner) {
    const labelParent = verticalFilters.closest('label.facet-checkbox');
    if (labelParent) {
      const filterLabel = labelParent.querySelector('span.filter-label');
      const bannerTitle = collectionBanner.querySelector('.collection-title .secondary-title');

      if (filterLabel && bannerTitle) {
        bannerTitle.textContent = filterLabel.textContent; 
        window.checkedFirstInputValue = verticalFilters.value;
      }
    }
  }

});

  
 


